import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import props from '../../../../redux/props'
import Modal from '../../../UI/Modal/Modal'
import Input from '../../../UI/Input/Input'
import { crud } from '@think-internet/zeus-frontend-package'
import { Arbeitspaket } from '../../../../types/Controlling/Arbeitspaket'
import { PlusIcon } from '@heroicons/react/24/outline'
import useLoadControllingKostenstellen from '../../../hooks/Controlling/useLoadControllingKostenstellen'
import { useParams } from 'react-router-dom'
import useToast from '../../../hooks/useToast'
import { setLocal } from '../../../../redux/action/local'
import useLoadControllingArbeitspakete from '../../../hooks/Controlling/useLoadControllingArbeitspakete'
import Dropdown from '../../../UI/Dropdown/Dropdown'

type Props = {
  callback: (uuid: string) => void
}

const Add: React.FC<Props> = ({ callback }) => {
  const [kostenstellen] = useLoadControllingKostenstellen()
  const [arbeitspakete] = useLoadControllingArbeitspakete()
  const arbeitspaketFeature = crud.use(props.CONTROLLING_ARBEITSPAKET)
  const [open, setOpen] = useState<boolean>(false)
  const t = useSelector((s) => s[props.TRANSLATION])
  const { companyUUID, kostenstelleUUID } = useParams()
  const [data, setData] = useState<Arbeitspaket>(null)
  const toast = useToast()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!data) {
      setData({
        companyUUID,
        kostenstelleUUID,
      })
    }
  }, [companyUUID, data, kostenstelleUUID])

  const create = async () => {
    const arbeitspaket: Arbeitspaket = await arbeitspaketFeature.create(data)
    if (arbeitspaket) {
      dispatch(setLocal(props.CONTROLLING_ARBEITSPAKET, [...arbeitspakete, arbeitspaket]))
      callback(arbeitspaket.uuid)
      setData(null)
      setOpen(false)
    } else {
      toast(t.controlling.arbeitspaketSelection.add.error)
    }
  }

  const toggle = () => setOpen(!open)

  const set = (key: keyof Arbeitspaket) => (value: any) => setData({ ...data, [key]: value })

  if (!data) return null
  return (
    <div>
      <div
        onClick={toggle}
        className="ml-auto bg-blue border border-blue hover:bg-white group transition-all cursor-pointer py-1 flex justify-center aspect-square h-full"
      >
        <PlusIcon className="stroke-white group-hover:stroke-blue w-8 box-border" />
      </div>
      <Modal onConfirm={create} show={open} onClose={toggle} title={t.controlling.arbeitspaketSelection.add.title}>
        <div className="flex flex-col gap-3 mt-3">
          <Dropdown
            items={kostenstellen.map((a) => ({ label: a.name, value: a.uuid }))}
            label={t.controlling.arbeitspaketSelection.add.selectKostenstelle}
            value={data.kostenstelleUUID}
            onChange={set('kostenstelleUUID')}
            required
          />
          <Input required label={t.generic.name} value={data.name} onChange={set('name')} />
        </div>
      </Modal>
    </div>
  )
}

export default Add
